import { TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { RefObject } from 'react';
import ForestDataGrid from './ForestDataGrid';
import { ListingProps } from '@/types/listing';
import usePropertyTabs from '@/components/frontend/PropertyTabs/hook';

const ForestInformationBlock = ({
  listing,
  forestData,
  sectionRef,
}: ListingProps & { sectionRef: RefObject<HTMLDivElement> }) => {
  const { t } = useTranslation('frontoffice');
  const { tabsProps, tabListProps, tabPanelsProps, tabPanelProps } =
    usePropertyTabs({
      sectionRef,
      prependTabs: [
        {
          key: 'combined',
          label: t('forest_data_combined', 'Kohteessa yhteensä'),
        },
      ],
    });

  if (!forestData) {
    return null;
  }

  if (forestData.properties.length === 1 && forestData.properties[0]) {
    return <ForestDataGrid forestData={forestData.properties[0]} t={t} />;
  }

  return (
    <>
      <Tabs {...tabsProps} gridColumn="aside !important">
        <TabList {...tabListProps} />
      </Tabs>
      <Tabs {...tabsProps}>
        <TabPanels {...tabPanelsProps}>
          <TabPanel {...tabPanelProps} key="combined">
            <ForestDataGrid forestData={forestData.combined} t={t} />
          </TabPanel>
          {listing.properties.map(({ id }, index) => {
            // need to declare this here for TS to understand that
            // it can't be null anymore when in the ternary branch below
            const propertyForestData = forestData.properties[index];

            if (!propertyForestData) {
              return (
                <TabPanel {...tabPanelProps} key={id}>
                  <Text>
                    {t('no_forest_on_property', 'Kiinteistöllä ei ole metsää')}
                  </Text>
                </TabPanel>
              );
            }

            return (
              <TabPanel {...tabPanelProps} key={id}>
                <ForestDataGrid forestData={propertyForestData} t={t} />
              </TabPanel>
            );
          })}
        </TabPanels>
      </Tabs>
    </>
  );
};

export default ForestInformationBlock;
